export const get_payment_method_details_panoramic_query = `
    query GetPaymentMethodDetails($option_id: Int!, $option_type: String!) {
        payment_method_details(option_id: $option_id, option_type: $option_type) {
            option_id
            option_type
            key
            type
            processor_type
            title
            payout_condition
            redirection_type
            window_size_width
            window_size_height
            is_spread_amount
            allow_new_card
            skip_customer_details
            show_amount
            payment_rails {
                key
                title
            }    
            additional_fields {
                name
                label
                type
                required
                data
                default_value
                sort_order
                is_account_identifier
                is_mutable
            }   
            templates {
                token
                label
                data
            }   
            payment_information {
                currency_list
                base_currency
                limits {
                    min_amount
                    max_amount
                }
                fees
            }
            card_tokenization_options {
              token_provider
              enabled
              card_funding_sources
              card_types
              currency_list
          }
        }
    }
`;
